import * as angular from "angular";
import { ContactMethodService } from "../services/contact-methods.service";

export class ContactMethodDataProvider {
    private $q: any;
    private resource: ContactMethodService;

    constructor($q: any, ContactMethodService: ContactMethodService) {
        this.$q = $q;
        this.resource = ContactMethodService;
    }

    all(): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.all().then(
            (response: object) => {
                let json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("ContactMethodDataProvider", ContactMethodDataProvider);
